import { moduleProviderFactory } from 'core/providers';
import { ContactDepartmentEdit, ContactDepartmentList } from 'application/contact-department/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.contact-department',
                pattern: '/contact-department',
                children: [
                    {
                        name: 'master.app.main.contact-department.list',
                        pattern: '',
                        tabTitle: 'CONTACT_DEPARTMENT.LIST.TITLE_SECONDARY',
                        component: ContactDepartmentList,
                        data: {
                            title: 'CONTACT_DEPARTMENT.LIST.TITLE_SECONDARY'
                        }
                    },
                    {
                        name: 'master.app.main.contact-department.create',
                        pattern: '/create',
                        tabTitle: 'Create Contact Department',
                        component: ContactDepartmentEdit,
                        authorization: 'importReferenceSection.create',
                        data: {
                            title: 'CONTACT_DEPARTMENT.CREATE.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.contact-department.edit',
                        pattern: '/edit/:id',
                        tabTitle: 'Edit Contact Department',
                        component: ContactDepartmentEdit,
                        authorization: 'importReferenceSection.update',
                        data: {
                            title: 'CONTACT_DEPARTMENT.EDIT.TITLE'
                        },
                    }                 
                ]
            }
        ],
        menu: [
            {
                title: 'MENU.FACILITIES',
                order: 4,
                icon: 'facilities',
                authorization: 'coreUserSection.read',
                subMenu: [
                    {
                        title: 'Contact Departments',
                        route: 'master.app.main.contact-department.list',
                        order: 4,
                    }                    
                ]
            }
        ]
    });
})();
